export default __webpack_public_path__ + "static/media/2B622F21-82C6-44F8-AB15-53987E80A384_1_105_c.fb1b6dbe.jpeg";